import { colorMap, textColorMap } from '@/utils/constants';
import { CanceledError } from 'axios';
import React, { Component, ErrorInfo } from 'react';
import { MuiBox, MuiContainer, MuiTypography } from '../material-ui';

class ErrorBoundary extends Component<unknown, { error?: Error; errorInfo?: ErrorInfo }> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: undefined,
      errorInfo: undefined,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { error, errorInfo } = this.state;
    const isCancelError = error instanceof CanceledError;

    if (error && !isCancelError) {
      return (
        <MuiContainer>
          <MuiBox color={textColorMap.dark.default} paddingY={4}>
            <MuiTypography component="h2" variant="h4">
              Something went wrong!
            </MuiTypography>
            <br />
            <MuiBox component="details" style={{ whiteSpace: 'pre-wrap' }}>
              <MuiBox
                component="code"
                style={{ backgroundColor: colorMap.black, display: 'block' }}
                paddingX={3}
                paddingY={2}
                mt={1}
              >
                <strong>{error.toString()}</strong>
                <br />
                <small>{errorInfo?.componentStack}</small>
              </MuiBox>
            </MuiBox>
          </MuiBox>
        </MuiContainer>
      );
    }

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

export default ErrorBoundary;
